export default "__VITE_ASSET__DFF2M22N__"